/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HoldCreatedShow } from './HoldCreatedShow';
import {
    HoldCreatedShowFromJSON,
    HoldCreatedShowFromJSONTyped,
    HoldCreatedShowToJSON,
    HoldCreatedShowToJSONTyped,
} from './HoldCreatedShow';
import type { HoldDateOutcome } from './HoldDateOutcome';
import {
    HoldDateOutcomeFromJSON,
    HoldDateOutcomeFromJSONTyped,
    HoldDateOutcomeToJSON,
    HoldDateOutcomeToJSONTyped,
} from './HoldDateOutcome';
import type { Hold } from './Hold';
import {
    HoldFromJSON,
    HoldFromJSONTyped,
    HoldToJSON,
    HoldToJSONTyped,
} from './Hold';

/**
 *
 * @export
 * @interface HoldMultiDayResult
 */
export interface HoldMultiDayResult {
    /**
     *
     * @type {string}
     * @memberof HoldMultiDayResult
     */
    message: string;
    /**
     *
     * @type {HoldCreatedShow}
     * @memberof HoldMultiDayResult
     */
    show: HoldCreatedShow | null;
    /**
     *
     * @type {Array<Hold>}
     * @memberof HoldMultiDayResult
     */
    holds: Array<Hold>;
    /**
     *
     * @type {Array<HoldDateOutcome>}
     * @memberof HoldMultiDayResult
     */
    outcomes: Array<HoldDateOutcome>;
    /**
     *
     * @type {Array<string>}
     * @memberof HoldMultiDayResult
     */
    skippedDates: Array<string>;
    /**
     *
     * @type {number}
     * @memberof HoldMultiDayResult
     */
    createdCount: number;
    /**
     *
     * @type {number}
     * @memberof HoldMultiDayResult
     */
    skippedCount: number;
}

/**
 * Check if a given object implements the HoldMultiDayResult interface.
 */
export function instanceOfHoldMultiDayResult(value: object): value is HoldMultiDayResult {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('show' in value) || value['show'] === undefined) return false;
    if (!('holds' in value) || value['holds'] === undefined) return false;
    if (!('outcomes' in value) || value['outcomes'] === undefined) return false;
    if (!('skippedDates' in value) || value['skippedDates'] === undefined) return false;
    if (!('createdCount' in value) || value['createdCount'] === undefined) return false;
    if (!('skippedCount' in value) || value['skippedCount'] === undefined) return false;
    return true;
}

export function HoldMultiDayResultFromJSON(json: any): HoldMultiDayResult {
    return HoldMultiDayResultFromJSONTyped(json, false);
}

export function HoldMultiDayResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): HoldMultiDayResult {
    if (json == null) {
        return json;
    }
    return {

        'message': json['message'],
        'show': HoldCreatedShowFromJSON(json['show']),
        'holds': ((json['holds'] as Array<any>).map(HoldFromJSON)),
        'outcomes': ((json['outcomes'] as Array<any>).map(HoldDateOutcomeFromJSON)),
        'skippedDates': json['skipped_dates'],
        'createdCount': json['created_count'],
        'skippedCount': json['skipped_count'],
    };
}

  export function HoldMultiDayResultToJSON(json: any): HoldMultiDayResult {
      return HoldMultiDayResultToJSONTyped(json, false);
  }

  export function HoldMultiDayResultToJSONTyped(value?: HoldMultiDayResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'message': value['message'],
        'show': HoldCreatedShowToJSON(value['show']),
        'holds': ((value['holds'] as Array<any>).map(HoldToJSON)),
        'outcomes': ((value['outcomes'] as Array<any>).map(HoldDateOutcomeToJSON)),
        'skipped_dates': value['skippedDates'],
        'created_count': value['createdCount'],
        'skipped_count': value['skippedCount'],
    };
}
